import { render, staticRenderFns } from "./StreamPlayer.vue?vue&type=template&id=28556c32&scoped=true&"
import script from "./StreamPlayer.vue?vue&type=script&lang=js&"
export * from "./StreamPlayer.vue?vue&type=script&lang=js&"
import style0 from "./StreamPlayer.vue?vue&type=style&index=0&id=28556c32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28556c32",
  null
  
)

export default component.exports